import { get } from '..';

const getTicketResolutionNote = (ticketId: string) => get(`chatbot-api/ticket-resolution-note/${ticketId}`);

export default getTicketResolutionNote;
